export default __webpack_public_path__ + "static/media/searchIcon.1f2a5e1e.svg";